import { Box, Typography } from '@mui/material'

const CancellationPolicy = ({ cancelPolicyData = [] }) => {

  return (
    <Box className='details_Section'>
      <Box className='details_header'>
        <Typography>Time Before Departure</Typography>
        <Typography sx={{ textAlign: 'end' }}>Charges</Typography>
      </Box>
      {cancelPolicyData?.map((obj) => (
        <Box className='details_list'>
          <Typography sx={{ width: `calc(100% - 80px)` }}>{obj.name}</Typography>
          <Typography>:</Typography>
          <Typography sx={{ width: '60px', textAlign: 'end' }}>{obj.value}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default CancellationPolicy